import type { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';

/**
 * Treat string "null" or "unknown" (or values containing them) as empty
 * so they are not shown or sent. Returns a new object with those values replaced by "".
 */
export function sanitizeSearchParams(
  params: AdvancedSearchURLParams | undefined
): AdvancedSearchURLParams {
  if (params === null || params === undefined || typeof params !== 'object') {
    return (params ?? {}) as AdvancedSearchURLParams;
  }
  const output = { ...params } as Record<string, unknown>;
  for (const key of Object.keys(output)) {
    const value = output[key];
    if (typeof value === 'string') {
      const trimmedValue = value.trim().toLowerCase();
      if (trimmedValue === 'null' || trimmedValue === 'unknown') {
        output[key] = '';
      }
    }
  }
  return output as unknown as AdvancedSearchURLParams;
}
